
import axios from "axios";
import { getErpToken } from "../utils/erpApi";

const ERP_API_URL = process.env.REACT_APP_ERP_API_URL;

export const getDispatchHistry = async (POrderId) => {
    const token = await getErpToken();

    try {
        const response = await axios.get(
            `${ERP_API_URL}/PO/GetDispatchHistory`,
            {
                params: {
                    POrderId: POrderId,
                },
                headers: {
                    Accept: "text/plain",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "ERP Inspection API:",
            `${ERP_API_URL}/PO/GetDispatchHistory`
        );

        console.error("POrderId:", POrderId);
        console.error("Status:", error.response?.status);
        console.error("Response:", error.response?.data);

        throw error;
    }
};
